import React, { useState } from "react";
import { Col, Container, Row, Spinner } from "reactstrap";
import { Navigate } from "react-router-dom";
import useTierAccess from "../../helpers/useTierAccess";
import Widget from "./Widgets";
import ResearchDisclaimer from "../../Components/Common/ResearchDisclaimer";
import BestSellingProducts from "./BestSellingProducts";
import RecentActivity from "./RecentActivity";
import RecentOrders from "./RecentOrders";
import Revenue from "./Revenue";
import SalesByLocations from "./SalesByLocations";
import Section from "./Section";
import StoreVisits from "./StoreVisits";
import TopSellers from "./TopSellers";
import PredictionsDashboard from "./PredictionsDashboard";

const DashboardEcommerce = () => {
  const tierAccess = useTierAccess();
  document.title = "Dashboard | ForecastNest - Crypto & Stock Prediction Platform";

  const [rightColumn, setRightColumn] = useState(true);
  const toggleRightColumn = () => {
    setRightColumn(!rightColumn);
  };

  // This dashboard shows system-generated forecasts, which a free member is not
  // entitled to read — the API returns nothing for them. Send them to their own
  // research instead of an empty page. Login and the catch-all route both land
  // here, so this one guard covers every path in.
  if (tierAccess.loading) {
    return (
      <div className="page-content">
        <Container fluid className="text-center py-5">
          <Spinner />
        </Container>
      </div>
    );
  }
  // Everything on this page is system forecasts, which are internal. A member
  // signing in lands on their own research instead — the thing this product
  // actually gives them.
  if (!tierAccess.canSeeSystemResearch) {
    return <Navigate to="/my-research" replace />;
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <ResearchDisclaimer className="mb-3" />
          <Row>
            <Col>
              <div className="h-100">
                {/* Only Predictions Dashboard - Main Content */}
                <PredictionsDashboard />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DashboardEcommerce;
